<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import czjzfcsInvoice from "./czjzfcsInvoice/index.vue";
import { mediumslateblue } from "color-name";
import {queryNsrinfo,czjzquery,czjzadd,czjzupdate,czjzsingleQuery,czjzclear,startTaxGather} from '../../../../../../api/cztds.js'
import config from'../../../../../../../configHttp.js'
import {MainFunction} from '../../../../../../components/util/Function/MainFunction.js'
export default {
  name: "",
  components: {
    czjzfcsInvoice,
  },
  props:{
  	mxsearch:{
		 type:Object,
		 default:{},
  	},
  	searchdata:{
		 type:Object,
		 default:{},
  	},
  	outlistx:{
		 type:Object,
		 default:{},
  	},
  },
  data: function () {
    return {
				maplist:[
					{
						value:null,
						item:'未采集'
					},
					{
						value:1,
						item:'未采集'
					},
					{
						value:2,
						item:'采集成功'
					},
					{
						value:3,
						item:'采集失败'
					},
					{
						value:4,
						item:'采集中'
					}
				],
		MainFunction:MainFunction,
		paramsx:{
			fangcbh:'',
			fangcmc:'',
			fangczgsws:'',
			chengzNsrsbh:'',
			chengzMc:'',
			shenbzjsr:'',
			chuzfcmj:'',
			zulqq:'',
			zulqz:'',
			yingnse:'',
			liuslfjmse:'',
			benqyjse:'',
			benqybtse:'',
			congjpkbz:'',
			congzpkbz:'',
			dailrysfzlx:'',
			dailrsfzhm:'',
			suosqqz:'',
			dailrmc:'',
			shoulr:'',
			shoulrq:'',
			shoulswjg:'',
			jianms:[{
				jianmdmhmc:'',
				jianmqsyf:this.$getdefultMonth(),
				jianmzzyf:this.$getdefultMonth(),
				jianmje:'',
				zujsr:'',
			},{
				jianmdmhmc:'',
				jianmqsyf:this.$getdefultMonth(),
				jianmzzyf:this.$getdefultMonth(),
				jianmje:'',
				zujsr:'',
			},{
				jianmdmhmc:'',
				jianmqsyf:this.$getdefultMonth(),
				jianmzzyf:this.$getdefultMonth(),
				jianmje:'',
				zujsr:'',
			}],
			yingnse:0,
			liuslfjmse:'',
			benqyjse:'',
			benqybtse:0,
		},
		nasrsbhlist:[],
      searchlist: getdata().searchlist,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      tableData: [{}],
      shaidiag: false,
	  conpid:'',
      invoicediag: false,
      tablekey: 0,
	  shoudata:1,
	  tabjson:getdata().tabjson
    };
  },
  mounted() {
		
	  queryNsrinfo().then(res=>{
	  	 if(res.data.code==1){
	  		this.nasrsbhlist = res.data.data
	  	}else{
	  		this.$message.error(res.data.msg)
	  	}
	  })
	  this.chpage()
  },
  created() {},
  methods: {
		Shui(e){
				this.$showConfirm({
				 		  message: "是否上传税源至税局?",
						  title:"标题",
				 		}).then((res) => {
				 		  if (res == "confirm") {
							 let params = {
							 	type:'3',
							 	detailIds:e.id
							 }
							 startTaxGather(params).then(res=>{
							 	if(res.data.code == 1 ){
							 		this.chpage();
							 	}else{
							 		this.$message.error(res.data.msg)
							 	}
							 })
				 		  }
				 		});
			
			
		},
	  updata(){
	  	this.chpage()
	  	this.$forceUpdate()
	  },
	  getJxzcInfo(){
		  this.chpage()
	  },
	  dsc(e) {
	  	this.$showConfirm({
	  		message: "确认删除?",
	  	}).then((res) => {
	  		if (res == "confirm") {
	  			let out = [e.id]
	  			this.dreremove(out)
	  		}
	  	});
	  
	  },
	  psc() {
			for(let index = 0 ; index < this.$refs.tablebox.getSelectionval().length ; index++){
				if(this.$refs.tablebox.getSelectionval()[index].caijFlag == '4' ){
					return this.$message.error('不能删除正在采集的数据')
				}
			}
	  	this.$showConfirm({
	  		message: "确认删除?",
	  	}).then((res) => {
	  		if (res == "confirm") {
	  			let out = this.$refs.tablebox.getSelectionval()
	  			let duoxuan = []
	  			if (out.length == 0) {
	  				this.$message.error('请勾选您需要删除的数据')
	  			} else {
	  				out.map(item => {
	  					duoxuan.push(item.id)
	  				})
	  				this.dreremove(duoxuan)
	  			}
	  		}
	  	});
	  },
	  dreremove(e) {
	  	let params = {
	  		id: this.outlistx.id,
	  		suosq: this.outlistx.suosq,
	  		mxIds: e
	  	}
	  	czjzclear(params).then(res => {
	  		if (res.data.code == 1) {
	  			this.chpage()
	  		} else {
	  			this.$message.error(res.data.msg)
	  		}
	  	})
	  },
	  dc(){
		  let out =this.$refs.tablebox.getSelectionval()
		  let paramsx=[]
			  out.map(item=>{
				paramsx.push(item.id)
			  })
		 let params = {
				downUrl:config.baseURL+"/land/detail/czjz/export",
				typeObj:{
					toForm:false,
					fileName:"明细从租计征使用税" + this.$timestampToStr(new Date(), "yyyyMMdd"),
					fileType:'xlsx',
				},
				params:{
					json:this.tabjson,
					taxDetailCzjzfcsExtendSearchInputDTO:{
						chuzfcmj:this.searchdata.chuzfcmj,
						fangcmc:this.searchdata.fangcmc,
						landId:this.outlistx.id
					},
					ids:paramsx
				}
		  }
		  this.$downloadcommon(params)
	  },
	  nextxz(e){
		  for (let a = 0 ; a < e.jianms.length ; a ++){
		  	if(!e.jianms[a].jianmdmhmc||e.jianms[a].jianmdmhmc==''||!e.jianms[a].zujsr||e.jianms[a].zujsr==''||!e.jianms[a].jianmje||e.jianms[a].jianmje==''){
		  		e.jianms.splice(a,1)
		  		a--
		  	}
		  }
		  if(this.shoudata<1){
			  e.id = this.conpid
			 czjzupdate(e).then(res=>{
				 if(res.data.code==1){
					 this.chpage()
					 this.invoicediag = false
				}else{
					this.$message.error(res.data.msg)
				}
			 })
		  }else{
			 e.landId = this.outlistx.id
			 e.nsrsbh = this.outlistx.nsrsbh
			 czjzadd(e).then(res=>{
				 if(res.data.code==1){
					this.chpage()
					this.invoicediag = false
				}else{
					this.$message.error(res.data.msg)
				}
			 })
		  }
	  },
    closediag() {
      this.invoicediag = false;
    },
	xzlog(e){
		 Object.keys(this.paramsx).map(key=>{
			 if(key!='jianms'){
				 this.paramsx[key] = ''
			 }else{
				for(let index = this.paramsx.jianms.length ; index < 3 ; index++){
					this.paramsx.jianms.push({
						jianmdmhmc: "",
						jianmje: "",
						jianmqsyf: "",
						jianmzzyf: "",
						zujsr: ""
					})
				}
				 this.paramsx.jianms.map(item=>{
					 Object.keys(item).map(item1=>{
						 item[item1] = ''
					 })
				 })
			 }
		 })
		 this.invoicediag = true
		 if(this.shoudata<1){
		 	this.shoudata = 1
		 }
		 this.shoudata += 1
	},
	bj(e){
		 let params = {
			 id:e.id
		 }
		 czjzsingleQuery(params).then(res=>{
			 if(res.data.code==1){
				let leng = res.data.data.jianms.length
				if(leng<3){
					for(let a = 0 ; a < 3 - leng ; a++){
						res.data.data.jianms.push({
							jianmdmhmc:'',
							jianmqsyf:null,
							jianmzzyf:null,
							fangcyz:'',
							jianmje:'',
						})
					}
				}
				 this.conpid = e.id
				this.paramsx =	res.data.data
				if(this.shoudata > 1){
					this.shoudata = 1
				}
				this.shoudata = this.shoudata - 1
				this.invoicediag = true
			}else{
				this.$message.error(res.data.msg)
			}
		 })
	},
	chpage(e){
		let params = JSON.parse(JSON.stringify(this.searchdata));
		params.current = this.pagination.pageNum;
		params.size = this.pagination.pageSize;
		params.suosq = this.outlistx.suosq
		params.landId = this.outlistx.id
		params.nsrsbh = this.outlistx.nsrsbh
		if(e){
			this.pagination.pageNum = 1
			this.pagination.paginationkey++
		}
		czjzquery(params).then(res=>{
			 if(res.data.code==1){
					this.tableData = res.data.data.records
					this.pagination.total = res.data.data.total
			}else{
				this.$message.error(res.data.msg)
			}
		})
	},
    sizechange(e) {
      this.pagination.pageSize = e;
    },
    currentChange(e) {
      this.pagination.pageNum = e;
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
    },

    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
